module.exports = __webpack_public_path__ + "static/media/tarjeta-de-presentacion.0845ffff.jpg";